import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { landingPathFor } from '@/lib/landing';
import { DashboardPage } from '@/modules/dashboard/DashboardPage';
import { useAuthStore } from '@/stores/auth-store';

/**
 * `/dashboard` is the *customer's* dashboard, and only theirs.
 *
 * Removing it from staff navigation is not enough on its own: the URL is still typeable, still
 * bookmarked from before the change, and still what a stale tab reloads into. Any of those puts
 * an operator back on a tenant page that reports their own account — which, with nothing in that
 * account, is an empty dashboard that looks exactly like a platform with nothing running on it.
 *
 * So the redirect lives on the route as well as in the menu, and both read the same answer from
 * {@link landingPathFor}.
 *
 * Impersonation is the one case where a staff account belongs here: their token *is* the
 * customer's for the duration, this is the page they went looking at, and `landingPathFor`
 * returns `/dashboard` for them — which lands on the render below rather than a redirect.
 */
export function DashboardRoute() {
  const { user } = useAuth();
  const impersonating = useAuthStore((s) => s.impersonation !== null);
  const home = landingPathFor(user, { impersonating });

  if (home !== '/dashboard') {
    return <Navigate to={home} replace />;
  }

  return <DashboardPage />;
}
